<form [formGroup]="savingProductAccountingForm">
  <div class="layout-row-wrap custom-gap responsive-column">
    <mat-radio-group
      class="flex-98 layout-row gap-5percent layout-column.lt-md radio-group-spacing"
      formControlName="accountingRule"
    >
      @for (accountingRule of accountingRuleData; track accountingRule; let i = $index) {
        <mat-radio-button [value]="i + 1">
          {{ 'labels.accounting.' + accountingRule | translate }}
        </mat-radio-button>
      }
    </mat-radio-group>

    <mat-divider class="flex-98"></mat-divider>

    @if (isCashOrAccrualAccounting()) {
      <div class="flex-fill layout-row-wrap gap-2percent layout-xs-column">
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Assets' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.savingsReferenceAccountId"
          [glAccountList]="assetAccountData"
          [required]="true"
          [inputLabel]="'Saving reference'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.overdraftPortfolioControlId"
          [glAccountList]="assetAccountData"
          [required]="true"
          [inputLabel]="'Overdraft portfolio'"
        >
        </LOSx-gl-account-selector>
        @if (isAccrualAccounting()) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="savingProductAccountingForm.controls.feesReceivableAccountId"
            [glAccountList]="assetAccountData"
            [required]="true"
            [inputLabel]="'Fees Receivable'"
          >
          </LOSx-gl-account-selector>
        }
        @if (isAccrualAccounting()) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="savingProductAccountingForm.controls.penaltiesReceivableAccountId"
            [glAccountList]="assetAccountData"
            [required]="true"
            [inputLabel]="'Penalties Receivable'"
          >
          </LOSx-gl-account-selector>
        }
        @if (isAccrualAccounting() && allowOverdraft.value) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="savingProductAccountingForm.controls.interestReceivableAccountId"
            [glAccountList]="assetAccountData"
            [required]="false"
            [inputLabel]="'Interest Receivable'"
          >
          </LOSx-gl-account-selector>
        }
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Liabilities' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.savingsControlAccountId"
          [glAccountList]="liabilityAccountData"
          [required]="true"
          [inputLabel]="'Saving control'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.transfersInSuspenseAccountId"
          [glAccountList]="liabilityAccountData"
          [required]="true"
          [inputLabel]="'Savings transfers in suspense'"
        >
        </LOSx-gl-account-selector>
        @if (isAccrualAccounting()) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="savingProductAccountingForm.controls.interestPayableAccountId"
            [glAccountList]="liabilityAccountData"
            [required]="true"
            [inputLabel]="'Interest Payable'"
          >
          </LOSx-gl-account-selector>
        }
        @if (isDormancyTrackingActive.value) {
          <LOSx-gl-account-selector
            class="flex-48"
            [inputFormControl]="savingProductAccountingForm.controls.escheatLiabilityId"
            [glAccountList]="liabilityAccountData"
            [required]="true"
            [inputLabel]="'Escheat liability'"
          >
          </LOSx-gl-account-selector>
        }
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Expenses' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.interestOnSavingsAccountId"
          [glAccountList]="expenseAccountData"
          [required]="true"
          [inputLabel]="'Interest on savings'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.writeOffAccountId"
          [glAccountList]="expenseAccountData"
          [required]="true"
          [inputLabel]="'Write-off'"
        >
        </LOSx-gl-account-selector>
        <mat-divider class="flex-98"></mat-divider>
        <h4 class="mat-h4 flex-98">{{ 'labels.heading.Income' | translate }}</h4>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.incomeFromFeeAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from fees'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.incomeFromPenaltyAccountId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Income from penalties'"
        >
        </LOSx-gl-account-selector>
        <LOSx-gl-account-selector
          class="flex-48"
          [inputFormControl]="savingProductAccountingForm.controls.incomeFromInterestId"
          [glAccountList]="incomeAccountData"
          [required]="true"
          [inputLabel]="'Overdraft Interest Income'"
        >
        </LOSx-gl-account-selector>
        <mat-divider class="flex-98"></mat-divider>
        <mat-checkbox class="flex-73" formControlName="advancedAccountingRules">{{
          'labels.heading.Advanced Accounting Rules' | translate
        }}</mat-checkbox>
        @if (savingProductAccountingForm.value.advancedAccountingRules) {
          <div class="flex-fill layout-row-wrap gap-1percent responsive-column">
            <div class="layout-row flex-100">
              <h4 class="mat-h4 flex-63">
                {{ 'labels.heading.Configure Fund Sources for Payment Channels' | translate }}
              </h4>
              <div class="flex-33">
                <button
                  type="button"
                  mat-raised-button
                  color="primary"
                  (click)="add('PaymentFundSource', paymentChannelToFundSourceMappings)"
                >
                  <fa-icon icon="plus" class="m-r-10"></fa-icon>
                  {{ 'labels.buttons.Add' | translate }}
                </button>
              </div>
            </div>
            <div class="flex-100">
              @if (paymentChannelToFundSourceMappings.value.length !== 0) {
                <table
                  class="flex-98 mat-elevation-z1"
                  mat-table
                  [dataSource]="paymentChannelToFundSourceMappings.value"
                >
                  <ng-container matColumnDef="paymentTypeId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Payment Type' | translate }}</th>
                    <td mat-cell *matCellDef="let paymentFundSource">
                      {{ paymentFundSource.paymentTypeId | find: paymentTypeData : 'id' : 'name' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="fundSourceAccountId">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fund Source' | translate }}</th>
                    <td mat-cell *matCellDef="let paymentFundSource">
                      {{ paymentFundSource.fundSourceAccountId | find: combinedAccountData : 'id' : 'name' }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                    <td mat-cell *matCellDef="let paymentFundSource; let i = index">
                      <button
                        mat-icon-button
                        color="primary"
                        (click)="edit('PaymentFundSource', paymentChannelToFundSourceMappings, i)"
                      >
                        <fa-icon icon="edit"></fa-icon>
                      </button>
                      <button mat-icon-button color="warn" (click)="delete(paymentChannelToFundSourceMappings, i)">
                        <fa-icon icon="trash"></fa-icon>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="paymentFundSourceDisplayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: paymentFundSourceDisplayedColumns"></tr>
                </table>
              }
            </div>
            @if (existCharges()) {
              <div class="flex-100 layout-row-wrap gap-0percent responsive-column">
                <h4 class="mat-h4 flex-63">{{ 'labels.heading.Map Fees to Specific Income Accounts' | translate }}</h4>
                @if (existCharges()) {
                  <div class="flex-33">
                    <button
                      type="button"
                      mat-raised-button
                      color="primary"
                      (click)="add('FeesIncome', feeToIncomeAccountMappings)"
                    >
                      <fa-icon icon="plus" class="m-r-10"></fa-icon>
                      {{ 'labels.buttons.Add' | translate }}
                    </button>
                  </div>
                }
                @if (feeToIncomeAccountMappings.value.length !== 0) {
                  <table class="flex-98 mat-elevation-z1" mat-table [dataSource]="feeToIncomeAccountMappings.value">
                    <ng-container matColumnDef="chargeId">
                      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fees' | translate }}</th>
                      <td mat-cell *matCellDef="let feesIncome">
                        {{ feesIncome.chargeId | find: chargeData : 'id' : 'name' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="incomeAccountId">
                      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
                      <td mat-cell *matCellDef="let feesIncome">
                        {{ feesIncome.incomeAccountId | find: incomeAccountData : 'id' : 'name' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                      <td mat-cell *matCellDef="let feesIncome; let i = index">
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="edit('FeesIncome', feeToIncomeAccountMappings, i)"
                        >
                          <fa-icon icon="edit"></fa-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="delete(feeToIncomeAccountMappings, i)">
                          <fa-icon icon="trash"></fa-icon>
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
                  </table>
                }
              </div>
            }
            @if (existCharges()) {
              <div class="flex-100 layout-row-wrap gap-0percent responsive-column">
                <h4 class="mat-h4 flex-63">
                  {{ 'labels.heading.Map Penalties to Specific Income Accounts' | translate }}
                </h4>
                <div class="flex-33">
                  <button
                    type="button"
                    mat-raised-button
                    color="primary"
                    (click)="add('PenaltyIncome', penaltyToIncomeAccountMappings)"
                  >
                    <fa-icon icon="plus" class="m-r-10"></fa-icon>
                    {{ 'labels.buttons.Add' | translate }}
                  </button>
                </div>
                @if (penaltyToIncomeAccountMappings.value.length !== 0) {
                  <table class="flex-98 mat-elevation-z1" mat-table [dataSource]="penaltyToIncomeAccountMappings.value">
                    <ng-container matColumnDef="chargeId">
                      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Penalty' | translate }}</th>
                      <td mat-cell *matCellDef="let penaltyIncome">
                        {{ penaltyIncome.chargeId | find: penaltyData : 'id' : 'name' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="incomeAccountId">
                      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
                      <td mat-cell *matCellDef="let penaltyIncome">
                        {{ penaltyIncome.incomeAccountId | find: incomeAccountData : 'id' : 'name' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                      <td mat-cell *matCellDef="let penaltyIncome; let i = index">
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="edit('PenaltyIncome', penaltyToIncomeAccountMappings, i)"
                        >
                          <fa-icon icon="edit"></fa-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)="delete(penaltyToIncomeAccountMappings, i)">
                          <fa-icon icon="trash"></fa-icon>
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
                  </table>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext [disabled]="!savingProductFormValid">
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
